import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { withRouter } from 'next/router';

const LayoutWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Medium, PingFang SC;

  video {
    outline: none;
    display: block;
    object-fit: fill; // 更改视频的充满状态
  }

  .container {
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
`;

const TalVideoLayout = ({ children, router }) => {
  const [videoCss, setVideoCss] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const getStyle = () => {
      const { innerWidth, innerHeight } = window;
      setVideoCss({
        width: innerWidth,
        height: innerHeight < 900 ? 900 : innerHeight
      });
    };
    getStyle();
    window.onresize = () => {
      getStyle();
    };
    return () => {
      window.onresize = null;
    };
  }, []);

  return (
    <LayoutWrapper>
      <video
        width={`${videoCss.width}`}
        height={`${videoCss.height}`}
        muted
        // eslint-disable-next-line react/no-unknown-property
        preloa="preload"
        loop
        autoPlay
        src={
          router.route === '/dolphin'
            ? '/static/video/main.mp4'
            : '/static/video/background-video.mp4'
        }
      />
      <div className="container">{children}</div>
    </LayoutWrapper>
  );
};

TalVideoLayout.propTypes = {
  children: PropTypes.node
};

// 后续会从redux中获取数据
export default connect(null, null)(withRouter(TalVideoLayout));
